/* eslint-disable camelcase */
export default {};
